import React from 'react';
import { NotificationProvider } from './components/notification/NotificationContext';
import NotificationDisplay from './components/notification/NotificationDisplay';

/**
 * AppProviders - Component to wrap application with all context providers
 * @param {Object} props
 * @param {React.ReactNode} props.children - Child components
 */
const AppProviders = ({ children }) => {
  return (
    <NotificationProvider>
      <NotificationDisplay />
      {children}
    </NotificationProvider>
  );
};

export default AppProviders;